import React, { useState } from 'react';
import { ActionButton, type ActionButtonData } from '../action-button/ActionButton';
import { t } from '../../services/locale';
import type { FormatUnix, ProfileBooking, ProfileBranch } from './profileBooking.types';
import { getCourseTime, getDayOfTheWeek } from './profileBookingRules';

type Props = Readonly<{
  booking: ProfileBooking;
  branch?: ProfileBranch | null;
  formatUnix: FormatUnix;
  getCloseActionData?: (booking: ProfileBooking) => ActionButtonData;
}>;

export function ProfileBookingCourseSchedule({
  booking,
  branch,
  formatUnix,
  getCloseActionData,
}: Props) {
  const [openOnPhone, setOpenOnPhone] = useState(false);
  const schedule = booking.model_obj?.schedule ?? [];

  if (!booking.model_obj || schedule.length === 0) {
    return null;
  }

  const days = schedule.find((slot) => slot.id === booking.session_id)?.days ?? [];
  const closeData = getCloseActionData?.(booking);

  return (
    <span className="more">
      <button
        type="button"
        className="profile-course-schedule-toggle"
        onClick={(event) => {
          event.stopPropagation();
          if (window.innerWidth <= 768) {
            setOpenOnPhone(true);
          }
        }}
      >
        {t('WEB_VIEW_SCHEDULE')}
      </button>
      <ul className={openOnPhone ? 'more-dropdown active' : 'more-dropdown'}>
        {days.map((day, index) => (
          <li key={`${day.days ?? 'day'}-${index}`}>
            <b>{getDayOfTheWeek(day)}</b> {getCourseTime(day, branch, formatUnix)}
          </li>
        ))}
        <li>
          {closeData ? (
            <span className="profile-action-button booking-show-more-close-action-button">
              <ActionButton
                data={{
                  ...closeData,
                  onClick: () => setOpenOnPhone(false),
                }}
              />
            </span>
          ) : null}
        </li>
      </ul>
    </span>
  );
}
